module.exports = __webpack_public_path__ + "static/img/team-build-02.5fca871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-02.png
// module id = yh6g
// module chunks = 1